export default __webpack_public_path__ + "static/media/icon-insights-website-optimization.1188e7d9.svg";